import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import * as Yup from "yup";
import GradeHistory from "./GradeHistory";
import { useNavigate } from "react-router-dom";
import "./style.css";
import FormikControl from "../../../componenets/FormikReusable/FormikControl";

const StudentForm = () => {
  const navigate = useNavigate();
  const initialvalues = {
    email: "",
    sname: "",
    rollno: "",
    standard: "",
    stds: [
      {
        std: "",
        remark: "",
        percentage: "",
      },
    ],
  };
  const validationschema = Yup.object({
    email: Yup.string().required("❗Required").email("Invalid Email Format"),
    sname: Yup.string().required("❗Required").min(2).max(25),
    rollno: Yup.number().required("❗Required").min(12),
    standard: Yup.number().required("❗Required"),
    stds: Yup.array().of(
      Yup.object().shape({
        remark: Yup.string().trim().required("❗Remarks Required").max(2),
        percentage: Yup.number().required("❗Percentage Required").max(100),
      })
    ),
  });
  const onSubmit = (values, onSubmitProps) => {
    console.log("FormData", values);
    navigate("/projects/2/gradedisplay", { state: values });
    onSubmitProps.setSubmitting(false);
    onSubmitProps.resetForm();
  };
  const options = [
    { key: "Select standard", value: "" },
    { key: "Std 1", value: "1" },
    { key: "Std 2", value: "2" },
    { key: "Std 3", value: "3" },
    { key: "Std 4", value: "4" },
    { key: "Std 5", value: "5" },
    { key: "Std 6", value: "6" },
    { key: "Std 7", value: "7" },
    { key: "Std 8", value: "8" },
    { key: "Std 9", value: "9" },
    { key: "Std 10", value: "10" },
    { key: "Std 11", value: "11" },
    { key: "Std 12", value: "12" },
  ];

  const SetStdsValue = (formik) => {
    //formik manage state
    //  console.log('formik old length value ' , formik.values.stds.length)
    if (formik.values.stds.length < formik.values.standard) {
      for (
        let i = formik.values.stds.length + 1;
        i < formik.values.standard;
        i++
      ) {
        formik.values.stds.push({ std: i, remark: "", percentage: "" });
      }
      //now set new length value
      console.log("new length values", formik.values.stds.length);
    } else {
      for (
        let i = formik.values.stds.length + 1;
        i > formik.values.standard;
        i--
      ) {
        formik.values.stds.pop();
      }
      // console.log('new length-pop',formik.values.stds.length)
    }
  };

  return (
    <>
      <Formik
        initialValues={initialvalues}
        onSubmit={onSubmit}
        validationSchema={validationschema}
        validateOnMount
      >
        {(formik) => {
          return (
            <>
              <div className="container">
                <div className="mainform">
                  <h1>Student Information Form</h1>
                  <Form>
                    <div class="row">
                      <div class="col-sm">
                        <FormikControl
                          control="input"
                          type="text"
                          label="Student Name"
                          name="sname"
                        />
                      </div>
                      <div class="col-sm">
                        <FormikControl
                          control="input"
                          type="text"
                          label="Roll No"
                          name="rollno"
                        />
                      </div>
                      <div class="col-sm">
                        <FormikControl
                          control="input"
                          type="email"
                          label="Email"
                          name="email"
                        />
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <FormikControl
                        control="select"
                        name="standard"
                        options={options}
                      />
                    </div>

                    {SetStdsValue(formik)}

                    {formik.values.standard === "1" &&
                    formik.values.standard !== "" ? (
                      <span className="t-red">
                        No need to Fill Previous Data
                      </span>
                    ) : (
                      <GradeHistory
                        length={formik.values.standard}
                      ></GradeHistory>
                    )}

                    <div className="button">
                      <button
                        type="reset"
                        disabled={!formik.dirty}
                        onClick={() => formik.resetForm()}
                      >
                        Reset
                      </button>
                      <button
                        type="submit"
                        disabled={!(formik.isValid || formik.isSubmitting)}
                      >
                        submit
                      </button>
                    </div>
                  </Form>
                </div>
                {console.log("errors", formik.errors)}
              </div>
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default StudentForm;
